/**
 * Skill-Namen tippfreundlich vergleichen (Skills entdecken, Okt 2026).
 *
 * Wer „praes“, „pras“ oder „Präs“ tippt, meint „Präsentieren“; wer „fussball“
 * tippt, meint „Fußball“. Auf dem Telefon fehlen Umlaute oft (englische Tastatur,
 * Autokorrektur aus), deshalb zählt ein Umlaut als Grundbuchstabe (ä → a) UND als
 * Umschreibung (ä → ae). Groß/klein egal, Akzente weg (é → e), ß → ss.
 *
 * Gefiltert wird im Browser über die ~50–100 Skills der Schule, kein Serverweg
 * beim Tippen. Für eine unscharfe Personensuche wäre `pg_trgm` der Weg (ANALYSE § 4).
 */

const UMLAUT_EXPANSIONS = { ä: 'ae', ö: 'oe', ü: 'ue' };

const base = value => String(value ?? '')
  .toLowerCase()
  .replace(/ß/g, 'ss')
  .replace(/\s+/g, ' ')
  .trim();

const stripMarks = value => value.normalize('NFD').replace(/[̀-ͯ]/g, '');

/** Grundform: klein, ß → ss, Umlaute und Akzente auf den Grundbuchstaben (ä → a). */
export const normalize = value => stripMarks(base(value));

/**
 * Beide Schreibweisen eines Textes: Grundform (ä → a) und Umschreibung (ä → ae).
 * Ohne Umlaut sind beide gleich, dann kommt nur eine zurück.
 */
export const normalizeVariants = (value) => {
  const lower = base(value);
  const folded = stripMarks(lower);
  const expanded = stripMarks(lower.replace(/[äöü]/g, ch => UMLAUT_EXPANSIONS[ch]));
  return folded === expanded ? [folded] : [folded, expanded];
};

/**
 * Passt `query` als Teilwort zu `name`? Leere Suche passt immer.
 * Jede Schreibweise der Suche wird gegen jede Schreibweise des Namens geprüft.
 */
export const matches = (name, query) => {
  const queries = normalizeVariants(query).filter(Boolean);
  if (queries.length === 0) return true;
  const names = normalizeVariants(name);
  return queries.some(q => names.some(n => n.includes(q)));
};

export default matches;
